import * as THREE from 'three';

/**
 * 光照系统模块
 * 为数字人场景配置环境光 + 方向光 + 半球光，确保皮肤材质呈现自然光影
 */
export class Lighting {
  /** @type {Map<string, THREE.Light>} */
  lights = new Map();

  constructor(scene) {
    this.#setupLights(scene);
  }

  #setupLights(scene) {
    // ========== 环境光 ==========
    // 提供全局基础照明，防止暗面纯黑
    const ambientLight = new THREE.AmbientLight('#ffffff', 0.6);
    scene.add(ambientLight);
    this.lights.set('ambient', ambientLight);

    // ========== 主方向光（模拟太阳光/主光源） ==========
    const mainLight = new THREE.DirectionalLight('#ffffff', 1.5);
    mainLight.position.set(5, 8, 5);
    // 启用阴影
    mainLight.castShadow = true;
    mainLight.shadow.mapSize.width = 2048;
    mainLight.shadow.mapSize.height = 2048;
    mainLight.shadow.camera.near = 0.5;
    mainLight.shadow.camera.far = 50;
    mainLight.shadow.camera.left = -5;
    mainLight.shadow.camera.right = 5;
    mainLight.shadow.camera.top = 5;
    mainLight.shadow.camera.bottom = -5;
    scene.add(mainLight);
    this.lights.set('main', mainLight);

    // ========== 补光方向光（弱化面部阴影） ==========
    const fillLight = new THREE.DirectionalLight('#b0c4ff', 0.5);
    fillLight.position.set(-3, 4, -2);
    scene.add(fillLight);
    this.lights.set('fill', fillLight);

    // ========== 半球光（天空-地面渐变光，增强环境感） ==========
    const hemiLight = new THREE.HemisphereLight('#dfeeff', '#222244', 0.4);
    scene.add(hemiLight);
    this.lights.set('hemi', hemiLight);

    // ========== 边缘光/背光（勾勒人物轮廓） ==========
    const rimLight = new THREE.DirectionalLight('#ffeedd', 0.6);
    rimLight.position.set(0, 3, -5);
    scene.add(rimLight);
    this.lights.set('rim', rimLight);
  }

  /**
   * 调整指定光照强度
   * @param {string} name - 光源名称（'ambient' | 'main' | 'fill' | 'hemi' | 'rim'）
   * @param {number} intensity - 光照强度
   */
  setIntensity(name, intensity) {
    const light = this.lights.get(name);
    if (light) {
      light.intensity = intensity;
    }
  }
}
